// SHOP dropdown — hover opens it on desktop (CSS); click/tap toggles it everywhere
const navDrop = document.querySelector('.nav-drop');
if (navDrop) {
  const navDropToggle = navDrop.querySelector('.nav-drop-toggle');
  navDropToggle.addEventListener('click', () => {
    const isOpen = navDrop.classList.toggle('open');
    navDropToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
  document.addEventListener('click', (e) => {
    if (!navDrop.contains(e.target)) {
      navDrop.classList.remove('open');
      navDropToggle.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      navDrop.classList.remove('open');
      navDropToggle.setAttribute('aria-expanded', 'false');
    }
  });
}

// Gallery wall — distribute items into columns left-to-right (row-major)
const items = Array.from(document.querySelectorAll('.g-item'));
const gallery = document.querySelector('.gallery');

function layoutGallery() {
  if (!gallery) return;
  const n = window.innerWidth > 1100 ? 4 : window.innerWidth > 700 ? 3 : 2;
  if (gallery.dataset.cols === String(n)) return;
  gallery.dataset.cols = n;
  gallery.innerHTML = '';
  const cols = Array.from({ length: n }, () => {
    const col = document.createElement('div');
    col.className = 'g-col';
    gallery.appendChild(col);
    return col;
  });
  items.forEach((item, i) => cols[i % n].appendChild(item));
}
layoutGallery();
window.addEventListener('resize', layoutGallery);

// Lightbox
const lightbox = document.getElementById('lightbox');
const lbImg = lightbox.querySelector('img');
const lbCap = lightbox.querySelector('figcaption');
let current = 0;

function show(i) {
  current = (i + items.length) % items.length;
  const item = items[current];
  const img = item.querySelector('img');
  lbImg.src = img.src;
  lbImg.alt = img.alt;
  lbCap.innerHTML = item.querySelector('figcaption').innerHTML;
}

function open(i) {
  show(i);
  lightbox.classList.add('open');
  lightbox.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function close() {
  lightbox.classList.remove('open');
  lightbox.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

items.forEach((item, i) => item.addEventListener('click', () => open(i)));
lightbox.querySelector('.lb-close').addEventListener('click', close);
lightbox.querySelector('.lb-prev').addEventListener('click', () => show(current - 1));
lightbox.querySelector('.lb-next').addEventListener('click', () => show(current + 1));
lightbox.addEventListener('click', (e) => { if (e.target === lightbox) close(); });

document.addEventListener('keydown', (e) => {
  if (!lightbox.classList.contains('open')) return;
  if (e.key === 'Escape') close();
  if (e.key === 'ArrowLeft') show(current - 1);
  if (e.key === 'ArrowRight') show(current + 1);
});
